<app-side-color-card color="primary-1">
  <div class="holder" content>
    <div class="upper-section">
      <button mat-button class="back" (click)="emitGoBack()" [disabled]="loading">
        <i class="uil uil-arrow-left" style="font-size: 25px"></i>
      </button>
      <h3 class="title">POSIÇÕES DE ESCANINHO</h3>
    </div>

    <div class="loading" *ngIf="loading">Carregando...</div>

    <div class="table" *ngIf="!loading">
      <div class="items" *ngIf="positions?.length; else emptyList">
        <div class="header">
          <div class="name column">Apelido</div>
          <div class="type column">Coordenada</div>
        </div>

        <div
          class="item"
          *ngFor="let position of positions"
          (click)="emitPositionClick(position)"
          [ngClass]="{
            'primary-1': position.type === 'STOCK',
            'secondary-3': position.type === 'DOCK',
            'out': position.type === 'EXPEDITION',
            'quality': position.type === 'QUALITY_CONTROL',
            'red': position.type === 'DIVERGENT_STOCK',
            'gray': position.type === 'STREET',
            'yellow': position.type === 'DAMAGES',
            'picking': position.type === 'PICKING',
            'provision': position.type === 'PROVISION',
            'picking-miscellaneous': position.type === 'PICKING_MISCELLANEOUS',
            'in': position.type === 'IN',
            'black': position.type === 'EXIT',
            'pigeonhole': position.type === 'PIGEONHOLE'
          }">
          <div class="name column">{{ getPositionLabel(position) }}</div>
          <div class="type column">{{ getCoordinates(position) }}</div>
        </div>
      </div>

      <ng-template #emptyList>
        <div class="empty">Nenhuma posição encontrada.</div>
      </ng-template>
    </div>
  </div>
</app-side-color-card>
